/**
 * NavigationArrows Component
 *
 * Displays left and right navigation arrows for the body slider.
 */
import React from "react";

const NavigationArrows = ({ onPrevClick, onNextClick }) => {
  return (
    <>
      <div className="slider-nav-arrow slider-nav-left" onClick={onPrevClick}>
        <div className="nav-arrow-indicator left"></div>
      </div>

      <div className="slider-nav-arrow slider-nav-right" onClick={onNextClick}>
        <div className="nav-arrow-indicator right"></div>
      </div>
    </>
  );
};

export default NavigationArrows;
